import { render, staticRenderFns } from "./BrAdminNotesSkeleton.vue?vue&type=template&id=049e7874&scoped=true&"
import script from "./BrAdminNotesSkeleton.vue?vue&type=script&lang=js&"
export * from "./BrAdminNotesSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BrAdminNotesSkeleton.vue?vue&type=style&index=0&id=049e7874&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e7874",
  null
  
)

export default component.exports